export default "__VITE_ASSET__DV_F9dbj__"